module.exports = __webpack_public_path__ + "static/media/no-image.cd6959e7.png";